module.exports = __webpack_public_path__ + "media/eye-contour-serum-medium.f0e5d9b1.mp4";